import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BPTMenu from '@/components/bpt/BPTMenu.vue';
import BPTQuestions from '@/components/bpt/BPTQuestions.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'BPTView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BPTMenu),
    _createVNode(BPTQuestions)
  ], 64))
}
}

})